var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.6"},React.createElement("path",{"d":"M18.7773 0H3.22266C1.44583 0 0 1.44583 0 3.22266V18.7773C0 20.5542 1.44583 22 3.22266 22H9.71094V14.2227H7.13281V10.3555H9.71094V7.73438C9.71094 5.60188 11.4456 3.86719 13.5781 3.86719H17.4883V7.73438H13.5781V10.3555H17.4883L16.8438 14.2227H13.5781V22H18.7773C20.5542 22 22 20.5542 22 18.7773V3.22266C22 1.44583 20.5542 0 18.7773 0Z","fill":"#262626"})));
}

Facebook.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
